import { render } from "./OmnichannelRevenueTable.vue?vue&type=template&id=a58bb61a"
import script from "./OmnichannelRevenueTable.vue?vue&type=script&lang=js"
export * from "./OmnichannelRevenueTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__